/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedMonitoringLogRowListResponse } from '../types/PaginatedMonitoringLogRowList';
import type { Direction } from '../types/Direction';
import type { EventType } from '../types/EventType';
import type { Level } from '../types/Level';
import type { Outcome } from '../types/Outcome';
import type { Source } from '../types/Source';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type MonitoringListRequest = {} | null | undefined;
export type MonitoringListResponse = PaginatedMonitoringLogRowListResponse;

export type MonitoringListQuery = {
  /**
   * ```yaml
   * in: query
   * name: created__gte
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  created__gte?: string;

  /**
   * ```yaml
   * in: query
   * name: created__lte
   * schema:
   *   type: string
   *   format: date-time
   * ```
   */
  created__lte?: string;

  /**
   * ```yaml
   * in: query
   * name: direction
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - IN
   *       - INTERNAL
   *       - OUT
   * description: |-
   *   * `OUT` - Odchozí
   *   * `IN` - Příchozí
   *   * `INTERNAL` - Interní
   * explode: true
   * style: form
   * ```
   */
  direction?: Direction[];

  /**
   * ```yaml
   * in: query
   * name: doc
   * schema:
   *   type: integer
   * ```
   */
  doc?: number;

  /**
   * ```yaml
   * in: query
   * name: epsi_doc
   * schema:
   *   type: integer
   * ```
   */
  epsi_doc?: number;

  /**
   * ```yaml
   * in: query
   * name: epsi_order
   * schema:
   *   type: integer
   * ```
   */
  epsi_order?: number;

  /**
   * ```yaml
   * in: query
   * name: event_type
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - CALL
   *       - CALLBACK
   *       - FLOW
   *       - JOB
   *       - LEGACY
   * description: |-
   *   * `CALL` - Odchozí volání
   *   * `CALLBACK` - Příchozí volání
   *   * `JOB` - Změna stavu jobu
   *   * `FLOW` - Krok workflow
   *   * `LEGACY` - Přenesený řádek
   * explode: true
   * style: form
   * ```
   */
  event_type?: EventType[];

  /**
   * ```yaml
   * in: query
   * name: failed_call__isnull
   * schema:
   *   type: boolean
   * ```
   */
  failed_call__isnull?: boolean;

  /**
   * ```yaml
   * in: query
   * name: job_id
   * schema:
   *   type: integer
   * ```
   */
  job_id?: number;

  /**
   * ```yaml
   * in: query
   * name: level
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     nullable: true
   *     enum:
   *       - CRITICAL
   *       - DEBUG
   *       - ERROR
   *       - INFO
   *       - WARNING
   * description: |-
   *   * `DEBUG` - Debug
   *   * `INFO` - Info
   *   * `WARNING` - Warning
   *   * `ERROR` - Error
   *   * `CRITICAL` - Critical
   * explode: true
   * style: form
   * ```
   */
  level?: Level[];

  /**
   * ```yaml
   * in: query
   * name: operation
   * schema:
   *   type: string
   * ```
   */
  operation?: string;

  /**
   * ```yaml
   * in: query
   * name: operation__icontains
   * schema:
   *   type: string
   * ```
   */
  operation__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: order
   * schema:
   *   type: integer
   * ```
   */
  order?: number;

  /**
   * ```yaml
   * in: query
   * name: outcome
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - ACCEPTED
   *       - CANCELLED
   *       - FAILED
   *       - REJECTED
   *       - SUCCEEDED
   *       - UNKNOWN
   * description: |-
   *   * `ACCEPTED` - Přijato ke zpracování
   *   * `SUCCEEDED` - Úspěch
   *   * `REJECTED` - Odmítnuto protistranou
   *   * `FAILED` - Selhalo
   *   * `CANCELLED` - Zrušeno
   *   * `UNKNOWN` - Neurčeno
   * explode: true
   * style: form
   * ```
   */
  outcome?: Outcome[];

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: source
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - DESA
   *       - DMVS
   *       - DMX
   *       - GEOREAL
   *       - ISTEM
   *       - JOBSCHEDULER
   *       - LEGACY
   *       - UAP
   * description: |-
   *   * `DMVS` - DMVS
   *   * `ISTEM` - ISTEM
   *   * `DESA` - DESA
   *   * `GEOREAL` - Georeál
   *   * `UAP` - ÚAP
   *   * `JOBSCHEDULER` - JobScheduler
   *   * `DMX` - DMX
   *   * `LEGACY` - Přenesená historie
   * explode: true
   * style: form
   * ```
   */
  source?: Source[];

  /**
   * ```yaml
   * in: query
   * name: state
   * schema:
   *   type: string
   * ```
   */
  state?: string;

  /**
   * ```yaml
   * in: query
   * name: urceny_editor_zps
   * schema:
   *   type: integer
   * ```
   */
  urceny_editor_zps?: number;
};

/**
 * GET /dmx-server/monitoring/
 *
 * ```yaml
 * operationId: monitoring_list
 * tags:
 *   - monitoring
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedMonitoringLogRowList'
 *     description: ''
 * ```
 */
export const monitoringListOperation = (rest?: MonitoringListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/monitoring/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/monitoring/' };
  };

/**
 * GET /dmx-server/monitoring/
 *
 * ```yaml
 * operationId: monitoring_list
 * tags:
 *   - monitoring
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedMonitoringLogRowList'
 *     description: ''
 * ```
 */
export const monitoringList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: MonitoringListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedMonitoringLogRowListResponse>> => {
  const operation = monitoringListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/monitoring/
 */
export const useMonitoringListResource = (
  query: MonitoringListQuery | null,
  useCached?: boolean,
): UseResource<MonitoringListResponse> => {
  return useResource<MonitoringListResponse>({
    path: query === null ? null : monitoringListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
